import * as unionOperator from '@arcgis/core/geometry/operators/unionOperator';
import Graphic from '@arcgis/core/Graphic';
import Extent from '@arcgis/core/geometry/Extent';


/**
 * A pre-computed Web Mercator (EPSG:3857) extent covering the contiguous United States, used to constrain map views and perform spatial queries.
 */
export const USAExtent = {
  xmin: -14174827.917549925,
  ymin: 2215459.8590684696,
  xmax: -7443477.458645953,
  ymax: 7332460.2805899475,
  spatialReference: { latestWkid: 3857, wkid: 102100 }
};

/**
 * Computes a unioned extent from an array of ArcGIS Graphics with geometry extents, returning null if no valid extents exist.
 */
export const getGraphicsExtent = (graphics: Graphic[]): Extent | null => {
  if (graphics.length === 0) return null;

  const extents = graphics.map(graphic => graphic.geometry?.extent).filter(Boolean) as Extent[];
  if (extents.length === 0) return null;
  const unionGeometry = unionOperator.executeMany(extents);
  const extent = unionGeometry?.extent;
  if (extent)
    return extent;
  return null;
};